import {FC} from 'react'
import {ErrorMessage, useField} from 'formik'
import {useIntl} from 'react-intl'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import BackButton from '../../../../../../../../components/Forms/Button/BackButton'
import CurrencyInput from 'react-currency-input-field'

const Step3: FC = () => {
  const [fieldGrossValue, , setFieldGrossValue] = useField('gross_value')
  const [fieldBaseIR, , setFieldBaseIR] = useField('base_IR')
  const [fieldAliquot, , setFieldAliquot] = useField('aliquot')
  const [fieldDeduction, , setFieldDeduction] = useField('deduction')
  const [fieldIncomeTax, , setFieldIncomeTax] = useField('income_tax')
  const [fieldNetValue, , setFieldNetValue] = useField('net_value')

  const intl = useIntl()
  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'CONTRACTS.TITLE_STEAP3'})}
          </h2>
          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'CONTRACTS.SUBTITLE_STEAP3'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da segunda linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.GROSS_VALUE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='issue_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={
                    fieldGrossValue.value ? parseFloat(fieldGrossValue.value) : undefined
                  }
                  onValueChange={(value) => setFieldGrossValue.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='gross_value' />
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.NET_VALUE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='maintenance_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={fieldNetValue.value ? parseFloat(fieldNetValue.value) : undefined}
                  onValueChange={(value) => setFieldNetValue.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='net_value' />
                </div>
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.DEDUCTION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='renovation_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={fieldDeduction.value ? parseFloat(fieldDeduction.value) : undefined}
                  onValueChange={(value) => setFieldDeduction.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='deduction' />
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.INCOME_TAX'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='renovation_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={fieldIncomeTax.value ? parseFloat(fieldIncomeTax.value) : undefined}
                  onValueChange={(value) => setFieldIncomeTax.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='income_tax' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.BASE_IR'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='renovation_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={fieldBaseIR.value ? parseFloat(fieldBaseIR.value) : undefined}
                  onValueChange={(value) => setFieldBaseIR.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='base_IR' />
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.ALIQUOT'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <CurrencyInput
                  name='renovation_cost'
                  className='form-control form-control-lg form-control-solid'
                  intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                  decimalScale={2}
                  allowDecimals={true}
                  defaultValue={fieldAliquot.value ? parseFloat(fieldAliquot.value) : undefined}
                  onValueChange={(value) => setFieldAliquot.setValue(value || 0)}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='aliquot' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da terceira linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step3}
